export default () => ({
  cart: [],
  address: null,
  memberId: null,
  shipping: null,
  firstName: '',
  lastName: '',
  isWalletFrozen: false
})
